<template>
  <div class="home">
    <!-- 轮播图模块 -->
    <div class="carousel-container page-container">
      <el-carousel :interval="2000" arrow="hover">
        <el-carousel-item v-for="(image, index) in images" :key="index">
          <template v-if="image.type == 'video'">
            <div class="carousel-video-wrapper">
              <button class="play-button" @click="jumpToVideo(image.imageUrl)">
                📺
              </button>
              <video
                class="carousel-video"
                :src="
                  'https://aiedu.jxnu.edu.cn/admin/api/downloadvideo?name=' +
                  image.imageUrl
                "
                controls
                loop
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </template>
          <template v-else>
            <img
              class="carousel-image"
              :src="
                'https://aiedu.jxnu.edu.cn/admin/api/downloadimage?name=' + image.imageUrl
              "
              alt="carousel image"
            />
          </template>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 通知模块 -->
    <div class="notification-container page-container">
      <el-row :gutter="20" justify="center">
        <el-col
          v-for="(notification, index) in notifications"
          :key="index"
          :xs="24"
          :sm="12"
          :md="6"
        >
          <el-card class="notification-card">
            <div class="notification-header">
              <h3 class="notification-title">{{ notification.title }}</h3>
              <el-button
                class="more-button"
                size="small"
                type="text"
                @click="goToNotification(index)"
              >
                更多
              </el-button>
            </div>
            <li
              class="notification-content"
              v-for="(item, contentIndex) in notification.content"
              :key="contentIndex"
              @click="downloadFile(notification, contentIndex)"
            >
              {{ item }}
            </li>

            <div v-if="index == 0">
              <el-carousel :interval="2000" arrow="hover">
                <el-carousel-item
                  v-for="(image, imgIndex) in carouselImages"
                  :key="imgIndex"
                  @click="goToLink(image)"
                  class="carousel-item"
                >
                  <div class="carousel-image-wrapper">
                    <img
                      class="carousel-image"
                      :src="
                        'https://aiedu.jxnu.edu.cn/admin/api/downloadimage?name=' +
                        image.imgurl
                      "
                      alt="carousel image"
                    />
                    <div class="carousel-caption">{{ image.title }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 快速链接模块 -->
    <div class="quick-links-container page-container">
      <h3 class="link-h3">友情链接</h3>
      <div class="quick-links-wrapper">
        <div
          class="quick-link-card"
          v-for="(link, index) in quickLinks"
          :key="index"
        >
          <a :href="link.url" target="_blank" class="quick-link">
            <h4 class="link-h4">{{ link.title }}</h4>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
export default {
  name: "HomeView",
  created() {
    this.getbanner();
    this.getNews();
    this.getInform();
    this.getRnews();
    this.getrn();
  },
  data() {
    return {
      images: "",
      carouselImages: "",
      notifications: [
        {
          title: "新闻动态",
          content: [],
          links: [],
        },
        {
          title: "通知公告",
          content: [],
          links: [],
        },
        {
          title: "科研动态",
          content: [],
          links: [],
        },
        {
          title: "学术报告",
          content: [],
          links: [],
        },
      ],
      quickLinks: [
        { title: "中华人民共和国教育部", url: "http://www.moe.gov.cn/" },
        { title: "国家自然科学基金委员会", url: "https://www.nsfc.gov.cn/" },
        {
          title: "江西省科学技术厅",
          url: "https://kjt.jiangxi.gov.cn/index.html",
        },
        { title: "江西省教育厅", url: "http://jyt.jiangxi.gov.cn/" },
        { title: "江西师范大学", url: "https://www.jxnu.edu.cn/main.htm" },
      ],
      news: [],
      newsc: [],
      newsu: [],
      inform: [],
      informc: [],
      informu: [],
      repro: [],
      reproc: [],
      reprou: [],
      rn: [],
      rnc: [],
      rnu: [],
    };
  },
  methods: {
    // 处理视频播放
    jumpToVideo(name) {
      const videoUrl = `https://aiedu.jxnu.edu.cn/admin/api/downloadvideo?name=${name}`;
      window.open(videoUrl, "_blank");
    },

    goToLink(image) {
      if (image.url) {
        const imurl =
          "https://aiedu.jxnu.edu.cn/admin/api/download?fileName=" + image.url;
        window.open(imurl, "_blank");
      } else {
        alert("Please enter a PDF ID");
      }
    },
    getbanner() {
      axios
        .get("https://aiedu.jxnu.edu.cn/admin/web/banner/getAllBanner")
        .then((res) => {
          this.images = res.data.data.list;
        })
        .catch((error) => {
          // 处理请求失败
          console.error("获取轮播图图片失败:", error);
        });
    },
    getNews() {
      axios
        .get("https://aiedu.jxnu.edu.cn/admin/web/news/newsList")
        .then((res) => {
          this.carouselImages = res.data.data.list;
          this.news = res.data.data.list.slice(0, 3);
          // console.log(this.carouselImages[0].url);
          for (let i = 0; i < this.news.length; i++) {
            this.newsc.push(this.news[i].title);
            this.newsu.push(this.news[i].url);
          }
          console.log(this.newsc);
          this.notifications[0].content = this.newsc;
          this.notifications[0].links = this.newsu;
        })
        .catch((error) => {
          // 处理请求失败
          console.error("获取新闻报告失败:", error);
        });
      console.log("11111" + this.notifications[0].content);
    },
    getInform() {
      axios
        .get("https://aiedu.jxnu.edu.cn/admin/web/inform/informList")
        .then((res) => {
          this.inform = res.data.data.list.slice(0, 3);
          for (let i = 0; i < this.inform.length; i++) {
            this.informc.push(this.inform[i].title);
            this.informu.push(this.inform[i].url);
            this.ca;
          }
          this.notifications[1].content = this.informc;
          this.notifications[1].links = this.informu;
        })
        .catch((error) => {
          // 处理请求失败
          console.error("获取通知公告列表失败:", error);
        });
    },
    getRnews() {
      axios
        .get("https://aiedu.jxnu.edu.cn/admin/web/researchNews/researchNewsList")
        .then((res) => {
          this.repro = res.data.data.list.slice(0, 3);
          console.log(this.repro[0]);
          for (let i = 0; i < this.repro.length; i++) {
            this.reproc.push(this.repro[i].title);
            this.reprou.push(this.repro[i].url);
          }
          console.log(this.reproc);
          this.notifications[2].content = this.reproc;
          this.notifications[2].links = this.reprou;
        })
        .catch((error) => {
          // 处理请求失败
          console.error("获取科研动态列表失败:", error);
        });
    },
    getrn() {
      axios
        .get("https://aiedu.jxnu.edu.cn/admin/web/progress/progressList")
        .then((res) => {
          this.rn = res.data.data.list;
          for (let i = 0; i < this.rn.length; i++) {
            this.rnc.push(this.rn[i].title);
            this.rnu.push(this.rn[i].url);
          }
          this.notifications[3].content = this.rnc;
          this.notifications[3].links = this.rnu;
        })
        .catch((error) => {
          // 处理请求失败
          console.error("获取学术动态列表失败:", error);
        });
    },
    goToNotification(index) {
      const paths = [
        "/newsdetai",
        "/noticeboard",
        "/researchnews",
        "/academicdynamics",
      ];
      this.$router.push(paths[index]);
    },
    downloadFile(notification, contentIndex) {
      const links = notification.links[contentIndex];

      if (!links) {
        alert("文件链接无效");
        return;
      }

      // 如果是完整的网址，直接访问
      if (links.startsWith("http://") || links.startsWith("https://")) {
        window.open(links, "_blank");
      } else {
        // 否则从本地接口下载
        const url =
          "https://aiedu.jxnu.edu.cn/admin/api/download?fileName=" +
          encodeURIComponent(links);
        window.open(url, "_blank");
      }
    },

    handleNotificationClick(notification, contentIndex) {
      const link = notification.links[contentIndex];

      if (link && link.endsWith(".pdf")) {
        // 如果是 PDF 链接，打开 PDF 文件
        window.open(link, "_blank");
      }

      if (link.includes("mp.weixin.qq.com")) {
        // 如果是 微信公众号链接，打开微信文章链接
        window.open(link, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.home {
  width: 1200px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch; /* 改为 stretch 让内容充满宽度 */
  padding: 0 16px;
  box-sizing: border-box;
}

/* 统一内容容器：宽度与导航栏一致 */
.page-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* 轮播图 */
.carousel-container,
.el-carousel,
.el-carousel__item {
  width: 100%;
  height: 450px;
  overflow: hidden;
}

.carousel-image,
.carousel-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 60%;
}

.carousel-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
}

/* 通知模块 */
.notification-container {
  margin-top: 30px;
  width: 100%;
}

.notification-card {
  height: 75%;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 260px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.notification-title {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}

.notification-content {
  font-size: 17px;
  color: #555;
  margin: 6px 0;
  cursor: pointer;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.more-button {
  font-size: 14px;
  color: #409eff;
  font-weight: bold;
  padding: 0;
}

/* 友情链接 */
.quick-links-container {
  margin-top: 10px;
  width: 100%;
}

.link-h3 {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.quick-links-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.quick-link-card {
  background-color: #00c0ff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 140px;
  max-width: 220px;
  width: 100%;
  text-align: center;
  padding: 20px;
  flex: 1 1 160px;
}
.quick-link {
  text-decoration: none;
  color: black;
}

.quick-link:hover .link-h4 {
  text-decoration: underline;
}

.link-h4 {
  font-size: 16px;
}
/* 新闻动态里面的轮播图 */

/* 轮播图容器大小 */
.notification-card .el-carousel {
  height: 270px; /* 保持轮播图高度 */
}

.notification-card .el-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.notification-card .carousel-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 图片样式 */
.notification-card .carousel-image {
  width: 100%; /* 宽度填充容器 */
  height: auto; /* 高度自适应 */
  object-fit: contain; /* 保持图片比例并在容器内显示 */
  object-position: center; /* 居中图片 */
}

/* 文字描述样式 */
.notification-card .carousel-caption {
  color: black;
  padding: 3px 10px;
  font-size: 12px;
  border-radius: 5px;
  white-space: nowrap;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis; /* 超出显示省略号 */
}
</style>
